/** Shared MUI DatePicker year-button styles so the selected year uses primary colors. */
export const SELECTED_YEAR_BUTTON_SX = {
  '&.MuiPickersYear-selected, &.Mui-selected': {
    backgroundColor: 'primary.main',
    color: '#fff !important',
    fontWeight: 600,
  },
  '&.MuiPickersYear-selected:hover, &.MuiPickersYear-selected:focus, &.Mui-selected:hover, &.Mui-selected:focus': {
    backgroundColor: 'primary.dark',
    color: '#fff !important',
  },
} as const;

/** Shared MUI DatePicker day-button styles so the selected date text is white. */
export const SELECTED_DAY_BUTTON_SX = {
  '&.Mui-selected': {
    backgroundColor: 'primary.main',
    color: '#fff !important',
    fontWeight: 600,
  },
  '&.Mui-selected:hover, &.Mui-selected:focus': {
    backgroundColor: 'primary.dark',
    color: '#fff !important',
  },
} as const;
